import L from "leaflet";
import type { TileSource } from "./tiles";

/** 이 횟수 이상 타일이 실패하면 소스가 죽은 것으로 본다. 산발적 실패와 구분하기 위한 값. */
const FAILURE_THRESHOLD = 6;

/**
 * 타일 레이어를 붙이되, 실패가 누적되면 폴백 소스로 갈아탄다.
 *
 * VWorld 인증키는 사용 기간이 있어 갱신하지 않으면 만료된다. 만료를 키 존재 여부로는
 * 알 수 없어서(문자열은 그대로 있다) 그냥 두면 타일만 404 가 나고 지도가 회색으로 남는다.
 * 운영 중에 조용히 그렇게 되는 것이 가장 나쁘다.
 *
 * 그래서 런타임에 실패를 세고, 임계값을 넘으면 키가 필요 없는 소스로 내린다.
 * 지도 품질은 떨어지지만 화면은 살아 있고, 콘솔 경고로 갱신 필요가 드러난다.
 */
export function addTileLayerWithFallback(
  map: L.Map,
  primary: TileSource,
  fallback: TileSource
): L.TileLayer {
  let failures = 0;
  let swapped = false;

  const layer = L.tileLayer(primary.url, {
    attribution: primary.attribution,
    maxZoom: primary.maxZoom,
  }).addTo(map);

  if (primary.url === fallback.url) return layer;

  layer.on("tileerror", () => {
    if (swapped) return;
    failures += 1;
    if (failures < FAILURE_THRESHOLD) return;

    swapped = true;
    console.warn(
      `[map] 타일 소스를 폴백으로 전환합니다 (${primary.attribution} → ${fallback.attribution}). ` +
        `인증키 만료·쿼터 초과 여부를 확인하세요.`
    );
    layer.setUrl(fallback.url);
    layer.options.maxZoom = fallback.maxZoom;
    // attribution 은 실제로 그리는 소스를 가리켜야 한다.
    map.attributionControl.removeAttribution(primary.attribution);
    map.attributionControl.addAttribution(fallback.attribution);
  });

  return layer;
}
